import React, {Component} from 'react'
import PropTypes from 'prop-types'
import LabelItem from './LabelItem'

class LabelsList extends Component {
    render() {
        const {labels, ...rest} = this.props

        return labels.map(label => <LabelItem key={label._id} {...rest} label={label}/>)
    }
}

LabelsList.propTypes = {
    labels: PropTypes.array.isRequired,
}

export default LabelsList
